import { SelectControl } from '../controls/select-control.model';
import { UiColumn } from '../ui-column';

export class AuditTypeSelect extends SelectControl {

  constructor(id: string, label: string, value: any);
  constructor(id: string, label: string, values: Array<any>);
  constructor(...arr: any[]) {
    var id = arr[0];
    var label = arr[1];
    var values = arr[2];
    var data: Array<any> = [];

    var isArray = values instanceof Array;

    if (isArray) {
      data = values;
    } else {
      data.push(values);
    }

    super(id, label, data, isArray);

    this.apiController = "AuditType";
    this.displayMember = "name";
    this.valueMember = "id";
    this.forceDataLoadOnOpen = true;
    this.clearDataOnOpen = true;
    this.columns = [
      //new UiColumn("ID", "ID", 200),
      new UiColumn("name", "Name", 150),
    ];
  }

}
